import { get } from '@atlassian/jira-common-rest/src/internal/latest/frontendconfig/properties/index.tsx';

type ProjectId = string;

type GetSuccess = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
};

const remoteGet = async ({
	projectId,
	properties,
}: {
	projectId: ProjectId;
	properties: string[];
}): Promise<GetSuccess> => {
	const { project } = await get({
		projectId,
		projectProperties: properties,
		consumerMeta: {
			id: 'remoteGet',
			packageName: 'jiraProjectPropertiesServices',
			teamName: 'jsd-shield',
		},
	});
	return project;
};

export default remoteGet;
